<template>
  <bita-modal
    :id="modalId"
    :title="title"
    :modal-lg="true"
    :isLoading="isLoading"
    @close="onCloseModal"
  >
    <div slot="body">
      <bita-form ref="form">
        <div slot="body">
          <div class="row">
            <bita-input
              type="factory_name"
              name="factory_name"
              label="نام کارخانه"
              rules="required"
              :validation-container-class="colWidth"
              input-class="form-control"
              v-model="dataForm.company_name"
            />
            <bita-input
              type="text"
              name="loading_fee"
              :label="$currencyLabel('هزینه بارگیری')"
              rules="fee"
              :validation-container-class="colWidth"
              input-class="form-control"
              v-model="dataForm.loading_fee"
              :has-thousand-seprator="true"
            />
            <bita-input
              type="text"
              name="company_code"
              label="کد شرکت"
              :validation-container-class="colWidth"
              input-class="form-control"
              v-model="dataForm.company_code"
            />

            <bita-select
              v-if="propsData.id"
              name="check_ebl"
              label="آیا بارنامه چک شود؟"
              placeholder="آیا بارنامه چک شود؟"
              :validation-container-class="colWidth"
              input-class="form-control"
              data-text-field="title"
              data-value-field="id"
              :data-source="items"
              v-model="dataForm.check_ebl"
              rules="required"
            />
            <bita-select
              name="city_id"
              label="شهر"
              placeholder="شهر را انتخاب کنید"
              :validation-container-class="colWidth"
              input-class="form-control"
              data-text-field="label"
              data-value-field="id"
              :data-source="allCities" 
              v-model="dataForm.city_id"
            />



          </div>
          <div class="row">
            <div class="col-12">
              <div class="alert alert-primary" role="alert">اطلاعات شخصی</div>
            </div>
            <bita-input
              type="text"
              name="name"
              label="نام"
              rules="required"
              :validation-container-class="colWidth"
              input-class="form-control"
              v-model="dataForm.name"
            />
            <bita-input
              type="text"
              name="family"
              label="نام خانوادگی"
              rules="required"
              :validation-container-class="colWidth"
              input-class="form-control"
              v-model="dataForm.family"
            />
            <bita-input
              type="text"
              name="username"
              label="نام کاربری"
              rules="required"
              :validation-container-class="colWidth"
              input-class="form-control"
              v-model="dataForm.username"
            />
            <bita-input
              type="number"
              name="national_code"
              label="کدملی"
              rules="required|irani"
              :validation-container-class="colWidth"
              input-class="form-control"
              v-model="dataForm.national_code"
            />
            <bita-input
              type="text"
              name="phone"
              label="شماره تماس"
              rules="required|mobile"
              :validation-container-class="colWidth"
              input-class="form-control"
              v-model="dataForm.phone"
            />
            <bita-input
              v-if="!propsData.id"
              type="password"
              name="password"
              label="رمزعبور"
              rules="required"
              :validation-container-class="colWidth"
              input-class="form-control"
              v-model="dataForm.password"
            />
            <bita-input
              type="postal_code"
              name="postal_code"
              label="کد پستی"
              rules="digits:10"
              :validation-container-class="colWidth"
              input-class="form-control"
              v-model="dataForm.postal_code"
            />
            <!-- <bita-multiselect
              name="users"
              label="کاربران"
              ref="usersMultiSelect"
              :validation-container-class="colWidth"
              input-class="form-control"
              :data-source="propsUsers"
              data-text-field="full_name"
              data-value-field="id"
              v-model="dataForm.user_ids"
            /> -->
            <bita-textarea
              name="address"
              class="col-12"
              inputClass="col-12 form-control"
              label="آدرس"
              v-model="dataForm.address"
            />
          </div>
        </div>
      </bita-form>
    </div>
    <div
      slot="footer"
      class="d-flex flex-column flex-md-row justify-content-between"
    >
      <div class="col-auto m-0 p-0 mb-2" v-if="!propsData.id">
        <bita-bootbutton
          type="primary"
          title="ذخیره"
          class="w-100"
          @click.native="handleSubmit()"
        />
      </div>
      <div class="col-auto m-0 p-0" v-if="propsData.id">
        <bita-bootbutton
          type="primary"
          title="بروزرسانی"
          class="w-100"
          @click.native="handleSubmit()"
        />
      </div>
      <div class="col-auto m-0 p-0">
        <bita-bootbutton
          class="w-100 bg-transparent text-danger border-0"
          type="danger"
          title="بستن"
          data-dismiss="modal"
          @click.native="
            () => {
              $emit('change-status-modal');
            }
          "
        />
      </div>
    </div>
  </bita-modal>
</template>
<script>
import Spinner from "../../../components/Spinner";
export default {
  components: { Spinner },
  props: {
    modalId: {},
    isLoading: {},
    title: {},
    onSubmit: {},
    propsData: {
      type: Object,
      default: {
        id: 0,
        name: "",
        family: "",
        national_code: "",
        phone: "",
        postal_code: "",
        address: "",
        password: "",
        company_name: "",
        company_code: "",
        check_ebl: 0,
        city_id:""
      },
    },
    allCities: {          
    type: Array,
    default: () => [],
  },
  },
  data() {
    return {
      colWidth: "col-lg-4 col-md-6 col-sm-6",
      dataForm: {},
    };
  },
  computed: {
    items: () => {
      return [
        { id: 0, title: "خیر" },
        { id: 1, title: "بله" },
      ];
    },
  },
  watch: {
    propsData: function(_data) {
      this.dataForm = _data;
    },
  },
  methods: {
    handleSubmit() {
      this.$refs.form.validate().then((result) => {
        if (result) {
          this.$emit("on-submit", this.dataForm);
        }
      });
    },
    reset() {
      this.$refs.form.reset();

      this.dataForm = {};
    },
    onCloseModal(e) {
      this.reset();
    },
  },
};
</script>
